import { Observable } from '../utils/observables/observable';
export var LifecycleEvent;
(function (LifecycleEvent) {
    LifecycleEvent["Fullscreen"] = "fullscreen";
    LifecycleEvent["Resume"] = "resume";
    LifecycleEvent["Suspend"] = "suspend";
})(LifecycleEvent || (LifecycleEvent = {}));
export class Lifecycle {
    observables = {};
    on(eventName, eventListener) {
        const observable = (this.observables[eventName] ||= new Observable());
        observable.registerObserver(eventListener, this);
    }
    off(eventName, eventListener) {
        const observable = this.observables[eventName];
        if (observable) {
            observable.unregisterObserver(eventListener);
        }
    }
    notify(eventName, value) {
        const observable = this.observables[eventName];
        if (observable) {
            observable.notifyObservers(value);
        }
    }
    isAppBackgrounded() {
        return false;
    }
    /** @deprecated please use {@link on} with {@link LifecycleEvent.Resume} */
    onResuming(eventListener) {
        this.on("resume" /* LifecycleEvent.Resume */, eventListener);
    }
    /** @deprecated please use {@link off} with {@link LifecycleEvent.Resume} */
    unregisterResuming(eventListener) {
        this.off("resume" /* LifecycleEvent.Resume */, eventListener);
    }
    /** @deprecated please use {@link on} with {@link LifecycleEvent.Suspend} */
    onSuspending(eventListener) {
        this.on("suspend" /* LifecycleEvent.Suspend */, eventListener);
    }
    /** @deprecated please use {@link off} with {@link LifecycleEvent.Suspend} */
    unregisterSuspending(eventListener) {
        this.off("suspend" /* LifecycleEvent.Suspend */, eventListener);
    }
    /** @deprecated please use {@link on} with {@link LifecycleEvent.Fullscreen} */
    onFullscreenChanged(eventListener) {
        this.on("fullscreen" /* LifecycleEvent.Fullscreen */, eventListener);
    }
    /** @deprecated please use {@link off} with {@link LifecycleEvent.Fullscreen} */
    unregisterFullscreenChanged(eventListener) {
        this.off("fullscreen" /* LifecycleEvent.Fullscreen */, eventListener);
    }
}
//# sourceMappingURL=lifecycle.js.map